export default __webpack_public_path__ + "static/media/txt-icon.d8686297.svg";